<template>
  <div id="shop-product-price-dialog">
    <v-dialog max-width="400px" scrollable v-model="dialogItem">
      <template v-slot:activator="{ on }">
        <v-btn @click="addItem()" color="primary" dark small v-on="on">Create</v-btn>
      </template>
      <v-card>
        <!-- <v-card-title>
          <h1 class="title head-page">Counsulting Topic</h1>
        </v-card-title>-->
        <v-divider></v-divider>
        <v-card-text>
          <v-container grid-list-xs>
            <v-layout align-center justify-center row wrap>
              <v-flex xs12>
                <v-text-field clearable label="Name" v-model="formData.name"></v-text-field>
                <v-text-field
                  clearable
                  label="Price"
                  type="number"
                  v-model.number="formData.price"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <base-delete-button
            :idx="formData.idx"
            module="ShopEditionProductItemPrice"
          ></base-delete-button>
          <v-spacer></v-spacer>
          <v-btn @click.stop="dialogItem = !dialogItem" color dark>Close</v-btn>
          <v-btn @click.prevent="doSubmit()" color="green" dark :loading="dialogLoading"
            >Save</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: 'shop-product-price-dialog',
  data() {
    return {
      formData: [],
      dialogLoading: false
    }
  },
  watch: {
    dialogItem() {
      if (this.$store.state.ShopEditionProductItemPrice.idx) {
        this.formData = this.$store.getters['ShopEditionProductItemPrice/getAll'].filter(
          item => item.idx == this.$store.state.ShopEditionProductItemPrice.idx
        )[0]
      } else {
        this.formData = []
      }
    }
  },
  computed: {
    dialogItem: {
      // getter
      get() {
        return this.$store.state.ShopEditionProductItemPrice.dialog
      },
      // setter
      set(newValue) {
        this.$store.commit('ShopEditionProductItemPrice/UPDATE_DIALOG', newValue)
      }
    }
  },
  created() {},
  methods: {
    async doSubmit() {
      try {
        const validate = await this.$validator.validateAll()
        if (validate) {
          this.dialogLoading = !this.dialogLoading
          const data = {
            ...this.formData,
            shopEditionProductItemId: this.$store.state.ShopEditionProductItem.idx
          }
          await this.$store.dispatch(`ShopEditionProductItemPrice/insert`, data)
          this.$store.commit(`ShopEditionProductItemPrice/UPDATE_DIALOG`, false)
          this.formData = []
          this.dialogLoading = !this.dialogLoading
        }
      } catch (error) {
        throw new Error(error)
      }
    },
    addItem() {
      this.$store.commit('ShopEditionProductItemPrice/UPDATE_DIALOG', true)
      this.$store.commit('ShopEditionProductItemPrice/SET_IDX', null)
    }
  }
}
</script>

<style lang="scss" scoped></style>
